import { TicketOfficeView } from '../../../types/ticket-office';
import { Poster, PosterProps } from '../../components/Poster';

export const getPosterProps = (view: TicketOfficeView): PosterProps | undefined => {
    const { state } = view;
    const { event } = state;

    return {
        url: event.posterUrl,
    };
};
